import React, { lazy } from 'react';

const ProjectForumForm = lazy(() =>
  import('./ProjectForumForm').then(module => ({
    default: module.ProjectForumForm,
  })),
);

const projectForumRoutes = [
  {
    props: { exact: true, path: '/project-forum-add/:contractId' },
    component: <ProjectForumForm mode="add" />,
  },
];

export default projectForumRoutes;
